import React, { createContext, useEffect, useState } from "react";
import { getSortedCollection } from "sprint-common-web";

import { GetOrdersAirlinesLookupResponse } from "../../../common/api/orders-api/airline/GetOrdersAirlinesLookupResponse";
import { useOrdersAirlineApi } from "../../../common/api/orders-api/airline/useOrdersAirlineApi";
import { mapToOrdersAirline, OrdersAirline } from "../types/OrdersAirline";

interface IOrderAirlinesDataContext {
    airlines: OrdersAirline[];
    isLoading: boolean;
}

export const OrderAirlinesDataContext = createContext<IOrderAirlinesDataContext>({
    airlines: [],
    isLoading: true
});

type OrderAirlinesDataProviderProps = React.PropsWithChildren<unknown>;

export const OrderAirlinesDataProvider: React.FunctionComponent<OrderAirlinesDataProviderProps> = ({
    children
}: OrderAirlinesDataProviderProps) => {
    const [airlines, setAirlines] = useState<OrdersAirline[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { getOrdersAirlinesLookup } = useOrdersAirlineApi();

    useEffect(() => {
        setIsLoading(true);

        getOrdersAirlinesLookup()
            .then((response: GetOrdersAirlinesLookupResponse) => {
                const newItems = response.items.map(mapToOrdersAirline);
                const sortedItems = getSortedCollection(newItems, "name");

                setAirlines(sortedItems);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return (
        <OrderAirlinesDataContext.Provider value={{ airlines, isLoading }}>
            {children}
        </OrderAirlinesDataContext.Provider>
    );
};
